import Controller from "./travelRequest.controller";
import template from "./travelRequest.html";

const travelRequest = {
  template,
  controller: Controller,
};

export default travelRequest;



// WEBPACK FOOTER //
// ./src/pages/travelRequest/travelRequest.component.js